import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { SelectItem } from '@mydocma/dynamic-form/lib/fields/filter-select/select-item';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'mydocma-mm-fields-delay-dropdown-tile',
  templateUrl: './fields-delay-dropdown-tile.component.html',
  styleUrls: ['./fields-delay-dropdown-tile.component.scss']
})
export class FieldsDelayDropdownTileComponent implements OnInit, OnDestroy {
  @Input() item: SelectItem & { data?: { delayImage?: ArrayBuffer } };
  imageUrl: SafeUrl;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    if (this.item?.data?.delayImage) {
      const blob = new Blob([this.item.data.delayImage], { type: 'image/png' });
      const url = URL.createObjectURL(blob);
      this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(url);
    }
  }

  ngOnDestroy(): void {
    if (this.imageUrl) {
      const url = (this.imageUrl as any).changingThisBreaksApplicationSecurity;
      if (url && url.startsWith('blob:')) {
        URL.revokeObjectURL(url);
      }
    }
  }
}